import { NgModule } from '@angular/core';
import { LoginRoutingModule } from './login-routing.module';
import { ShareModule } from '../share.module';
import { LoginComponent } from './login.component';

@NgModule({
  declarations: [
    LoginComponent,
  ],
  imports: [
    LoginRoutingModule,
    ShareModule
  ],
  providers: [],
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts